import { Controller } from '@hotwired/stimulus'

// Code-snippet tabs (curl / Python / JavaScript).
//
// Used on /api (T1.8). Each `.mkt-code` block has its own controller
// instance with its own tabs and panels — no leakage between blocks.
//
// Markup contract:
//   <div class="mkt-code" data-controller="code-tabs">
//     <div class="mkt-code__tabs" role="tablist">
//       <button role="tab" data-code-tabs-target="tab"
//               data-action="click->code-tabs#select"
//               data-panel="hero-curl"
//               aria-selected="true">curl</button>
//       …
//     </div>
//     <div class="mkt-code__panel" id="hero-curl"
//          data-code-tabs-target="panel" data-active="true">…</div>
//     …
//   </div>
export default class extends Controller {
  static targets = ['tab', 'panel']

  select(event) {
    const tab = event.currentTarget
    const panelId = tab.getAttribute('data-panel')
    if (!panelId) return

    this.tabTargets.forEach((t) => {
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false')
    })
    this.panelTargets.forEach((p) => {
      if (p.id === panelId) {
        p.setAttribute('data-active', 'true')
      } else {
        p.removeAttribute('data-active')
      }
    })
  }
}
